export const ASTRO_NODEJS_IMPORT_YAML = `project:
  name: recipe-astro
  tags:
    - zerops-recipe

services:
  - hostname: app
    type: nodejs@20
    enableSubdomainAccess: true
    buildFromGit: https://github.com/zeropsio/recipe-astro-nodejs`;
